import { openMetadataApiClient } from '@/shared/api/core/axios-instance';
import type { JsonPatchOperation } from '@/shared/types/common';

import type { TagDetailItem } from '@/entities/tags/domain';

type UpdateTagRequest = {
  tagId: string;
  operations: JsonPatchOperation[];
};

export const updateTagApi = async ({ tagId, operations }: UpdateTagRequest): Promise<TagDetailItem> => {
  try {
    const { data } = await openMetadataApiClient.patch<TagDetailItem>(`/tags/${tagId}`, operations, {
      headers: {
        'Content-Type': 'application/json-patch+json',
      },
    });
    return data;
  } catch (error) {
    console.error('Failed to update tag:', error);
    throw error;
  }
};

export type { UpdateTagRequest };
